<nav style="background-color: #491176; height: 76px">
	<div class="flex flex-wrap items-center justify-between mx-auto py-[5px]">
		<button (click)="navigateToHome()" class="flex items-center space-x-3 rtl:space-x-reverse">
			<img src="/assets/images/jotto-logo-(yellow).png" class="h-[66px] padleft" alt="Jotto Logo" />
		</button>
		<div class="custom-hidden-lg" style="padding-right: 20px">
			<button (click)="toggleNavbar()" class="inline-flex items-center justify-center p-2 w-10 h-10 text-sm rounded-lg hover:bg-[#592187] focus:outline-none focus:ring-2 focus:ring-gray-200" style="color: #fbd364" [ngClass]="{ highlight: navbarOpen }">
				<span class="sr-only">Open main menu</span>
				<svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
					<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1h15M1 7h15M1 13h15" />
				</svg>
			</button>
		</div>
		<div class="custom-hidden-sm flex items-center pr-[40px] pd-[5px]">
			<button (click)="navigateToHome()" class="custom-link" aria-current="page">Home</button>
			<button (click)="navigateToPricing()" class="custom-link" aria-current="page">Pricing</button>

			<button (click)="navigateToCompany()" class="custom-link">Company</button>
			<button (click)="navigateToFAQ()" class="custom-link">FAQ</button>
			<button (click)="navigateToSupport()" class="custom-link">Support</button>
			<div class="nav-divider"></div>
			<a href="https://console.jotto.me/auth/signin" class="custom-link mr-[20px]">Login</a>
		</div>

		<div class="custom-hidden-lg" [ngClass]="{ hidden: !navbarOpen, 'w-full': true, 'lg:flex': true, 'lg:w-auto': true }" [@dropdownAnimation]="navbarOpen ? 'visible' : 'hidden'">
			<ul class="flex mt-1 w-full justify-around items-center dropdown">
				<li class="flex items-center">
					<button (click)="navigateToHome()" class="custom-link" aria-current="page">Home</button>
				</li>

				<li class="flex items-center">
					<button (click)="navigateToPricing()" class="custom-link">Pricing</button>
				</li>
				<li class="flex items-center">
					<button (click)="navigateToCompany()" class="custom-link">Company</button>
				</li>
				<li class="flex items-center">
					<button (click)="navigateToFAQ()" class="custom-link">FAQ</button>
				</li>
				<li class="flex items-center">
					<button (click)="navigateToSupport()" class="custom-link">Support</button>
				</li>
				<div class="nav-divider"></div>
				<li class="flex items-center">
					<a href="https://console.jotto.me/auth/signin" class="custom-link mr-[20px]">Login</a>
				</li>
			</ul>
		</div>
	</div>
</nav>
